import styled, { css, DefaultTheme } from "styled-components";
import InputMask from "react-input-mask";

import { Tooltip } from "../Tooltip";

type LabelProps = {
  fontSize?: number;
};
interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
  isReadOnly: boolean;
}

export const Label = styled.p<LabelProps>`
  ${({ theme, fontSize }) => css`
    color: ${theme.colors.title};
    text-align: left;
    font-size: ${fontSize}px;
    margin-bottom: 5px;
  `}
`;

const containerModifiers = {
  isErrored: (theme: DefaultTheme) => css`
    border-color: ${theme.colors.error};
    padding-left: 28px;
  `,

  isFocused: (theme: DefaultTheme) => css`
    border-color: ${theme.colors.primary_light};
  `,
};

export const Container = styled.div<ContainerProps>`
  ${({ theme, isErrored, isFocused, isReadOnly }) => css`
    background: ${theme.colors.menu_background};
    border-radius: 10px;
    position: relative;

    min-height: 50px;
    width: 100%;
    border: 1px solid #232129;
    color: ${theme.colors.title};
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    & + div {
      margin-top: 8px;
    }

    ${!!isFocused && !isReadOnly && containerModifiers.isFocused(theme)};
    ${!!isErrored && containerModifiers.isErrored(theme)};

    input {
      width: 100%;
      min-height: 50px;
      background-color: transparent;
      color: ${theme.colors.text_extra_light};
      padding: 14px;
      flex: 1;
      border-radius: 10px;

      border: 0;
      outline: none;

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 24px ${theme.colors.menu_background} inset;
        -webkit-text-fill-color: ${theme.colors.text_extra_light};
        min-height: 47px;

        filter: none;
      }

      &:read-only {
        opacity: 0.7;
      }

      &:disabled {
        cursor: not-allowed;
      }
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input[type="date"]::-webkit-calendar-picker-indicator {
      filter: invert(0.7);
      position: absolute;
      right: 3%;
    }

    input[type="search"]::-webkit-search-decoration,
    input[type="search"]::-webkit-search-cancel-button,
    input[type="search"]::-webkit-search-results-button,
    input[type="search"]::-webkit-search-results-decoration {
      -webkit-appearance: none;
    }

    svg {
      margin-right: 16px;
    }
  `}
`;

export const MaskInput = styled(InputMask)`
  ${({ theme }) => css`
    input {
      width: 100%;

      background-color: transparent;
      color: ${theme.colors.text_extra_light};
      margin-top: 2px;
      padding: 14px;

      border: 0;
      outline: none;

      &:-webkit-autofill {
        -webkit-box-shadow: 0 0 0 24px ${theme.colors.menu_background} inset;
        -webkit-text-fill-color: ${theme.colors.text_extra_light};

        filter: none;
      }
    }
  `}
`;

export const ButtonIcon = styled(Tooltip)`
  ${({ theme }) => css`
    position: absolute;
    right: 18px;
    top: 30%;
    cursor: pointer;

    & > img {
      width: 20px;
      height: 20px;
    }

    span {
      background: ${theme.colors.primary};
      color: ${theme.colors.background};
      text-align: center;

      &::before {
        border-color: ${theme.colors.primary} transparent;
      }
    }
  `}
`;

export const Error = styled(Tooltip)`
  ${({ theme }) => css`
    position: absolute;
    top: 14px;
    left: 4px;

    height: 20px;
    margin-left: 12px;

    svg {
      margin: 0;
    }
    span {
      background: ${theme.colors.error};
      color: ${theme.colors.text_extra_light};
      &::before {
        border-color: ${theme.colors.error} transparent;
      }
    }
  `}
`;

export const WrapperInputIcon = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
`;
